import { useEffect, useState } from "react";
import { DeviceMobile, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "./ui/button";

export const InstallAppButton = () => {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(
    window.matchMedia("(display-mode: standalone)").matches
  );
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!localStorage.getItem("install-banner-dismissed")) setShowBanner(true);
    };
    const onInstalled = () => { setInstalled(true); setDeferred(null); setShowBanner(false); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") toast.success("App installed! Check your home screen.");
      setDeferred(null);
      setShowBanner(false);
    } else {
      const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
      toast.info(
        isIOS
          ? "iPhone: tap Share in Safari, then choose 'Add to Home Screen'"
          : "Open the browser menu (⋮) and choose 'Install app' or 'Add to Home screen'",
        { duration: 8000 }
      );
    }
  };

  if (installed) return null;

  return (
    <>
      <Button data-testid="install-app-button" variant="ghost" size="sm" className="w-full mt-1 text-xs justify-start px-2" onClick={install}>
        <DeviceMobile size={14} className="mr-1.5" /> Install App
      </Button>
      {showBanner && (
        <div data-testid="install-banner" className="fixed bottom-24 md:bottom-4 inset-x-4 sm:left-auto sm:w-80 z-50 bg-secondary text-secondary-foreground rounded-xl shadow-xl p-4 flex items-center gap-3">
          <DeviceMobile size={26} className="shrink-0 text-primary" />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-bold">Install Anuj Solar App</div>
            <div className="text-xs opacity-70">Open straight from your home screen</div>
          </div>
          <Button data-testid="install-banner-install" size="sm" onClick={install}>Install</Button>
          <button data-testid="install-banner-close" className="p-1 opacity-60 hover:opacity-100"
            onClick={() => { setShowBanner(false); localStorage.setItem("install-banner-dismissed", "1"); }}>
            <X size={16} />
          </button>
        </div>
      )}
    </>
  );
};
